import React, { useState, useEffect } from "react";
import { useNavigate  } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";

/*** 
@purpose : Functional component
@Parameter : {props}
**/
function NursingInfo(props) {
  const navigate = useNavigate();
  const [lang] = useTranslation("language");
  const [customerNotFound, setCustomerNotFound] = useState();
  const [details, setDetails] = useState([]);

  useEffect(() => {
    setDetails(props.details);
  }, []);

  /*** 
    @purpose : Change route
    @Parameter : {e, page}
    **/
  const changeRoute = (e, page) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page);
  };

  return (
    <>
      <div className="org-main">
        <div className="org-wrapper1">
          <h4 className="primary-title">
            {lang("OrganizationMenu.nursingInfo")}
          </h4>
          <div className="card">
            <div className="card-body">
              <div className="table-responsive mb-0 max-height">
                <table className="table" aria-describedby="table">
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th scope="col">
                        <div className="cursor-pointer">
                          {lang("organizationDetails.flag")}
                        </div>
                      </th>
                      <th scope="col">
                        <div className="cursor-pointer">
                          {lang("organizationDetails.nursingType")}
                        </div>
                      </th>
                      <th scope="col">
                        <div className="cursor-pointer">
                          {lang("organizationDetails.numberOfWards")}
                        </div>
                      </th>
                      <th scope="col">
                        <div className="cursor-pointer">
                          {lang("organizationDetails.numberOfWards")}
                        </div>
                      </th>
                      <th scope="col">
                        <div className="cursor-pointer">
                          {lang("organizationDetails.cancelledDate")}
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowSpan="7">一般病棟 </td>
                      <td>
                        {details.general_ward_flag
                          ? details.general_ward_flag
                          : ""}
                      </td>
                      <td>
                        {details.general_ward_1_nursing_type
                          ? details.general_ward_1_nursing_type
                          : ""}
                      </td>
                      <td>
                        {details.general_ward_1_number_of_wards
                          ? details.general_ward_1_number_of_wards
                          : ""}
                      </td>
                      <td>
                        {details.general_ward_1_number_of_beds
                          ? details.general_ward_1_number_of_beds
                          : ""}
                      </td>
                      <td>
                        {details.general_ward_1_approved_year
                          ? details.general_ward_1_approved_year
                          : "" + "/" + details.general_ward_1_approved_month
                            ? details.general_ward_1_approved_month
                            : "" + "/" + details.general_ward_1_approved_day
                              ? details.general_ward_1_approved_day
                              : ""}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {details.general_ward_2_nursing_type
                          ? details.general_ward_2_nursing_type
                          : ""}
                      </td>
                      <td>
                        {details.general_ward_2_number_of_wards
                          ? details.general_ward_2_number_of_wards
                          : ""}
                      </td>
                      <td>
                        {details.general_ward_2_number_of_beds
                          ? details.general_ward_2_number_of_beds
                          : ""}
                      </td>
                      <td>
                        {details.general_ward_2_approved_year
                          ? details.general_ward_2_approved_year
                          : "" + "/" + details.general_ward_2_approved_month
                            ? details.general_ward_2_approved_month
                            : "" + "/" + details.general_ward_2_approved_day
                              ? details.general_ward_2_approved_day
                              : ""}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {details.general_ward_3_nursing_type
                          ? details.general_ward_3_nursing_type
                          : ""}
                      </td>
                      <td>
                        {details.general_ward_3_number_of_wards
                          ? details.general_ward_3_number_of_wards
                          : ""}
                      </td>
                      <td>
                        {details.general_ward_3_number_of_beds
                          ? details.general_ward_3_number_of_beds
                          : ""}
                      </td>
                      <td>
                        {details.general_ward_3_approved_year
                          ? details.general_ward_3_approved_year
                          : "" + "/" + details.general_ward_3_approved_month
                            ? details.general_ward_3_approved_month
                            : "" + "/" + details.general_ward_3_approved_day
                              ? details.general_ward_3_approved_day
                              : ""}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {details.general_ward_4_nursing_type
                          ? details.general_ward_4_nursing_type
                          : ""}
                      </td>
                      <td>
                        {details.general_ward_4_number_of_wards
                          ? details.general_ward_4_number_of_wards
                          : ""}
                      </td>
                      <td>
                        {details.general_ward_4_number_of_beds
                          ? details.general_ward_4_number_of_beds
                          : ""}
                      </td>
                      <td>
                        {details.general_ward_4_approved_year
                          ? details.general_ward_4_approved_year
                          : "" + "/" + details.general_ward_4_approved_month
                            ? details.general_ward_4_approved_month
                            : "" + "/" + details.general_ward_4_approved_day
                              ? details.general_ward_4_approved_day
                              : ""}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {details.general_ward_5_nursing_type
                          ? details.general_ward_5_nursing_type
                          : ""}
                      </td>
                      <td>
                        {details.general_ward_5_number_of_wards
                          ? details.general_ward_5_number_of_wards
                          : ""}
                      </td>
                      <td>
                        {details.general_ward_5_number_of_beds
                          ? details.general_ward_5_number_of_beds
                          : ""}
                      </td>
                      <td>
                        {details.general_ward_5_approved_year
                          ? details.general_ward_5_approved_year
                          : "" + "/" + details.general_ward_5_approved_month
                            ? details.general_ward_5_approved_month
                            : "" + "/" + details.general_ward_5_approved_day
                              ? details.general_ward_5_approved_day
                              : ""}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {details.general_ward_6_nursing_type
                          ? details.general_ward_6_nursing_type
                          : ""}
                      </td>
                      <td>
                        {details.general_ward_6_number_of_wards
                          ? details.general_ward_6_number_of_wards
                          : ""}
                      </td>
                      <td>
                        {details.general_ward_6_number_of_beds
                          ? details.general_ward_6_number_of_beds
                          : ""}
                      </td>
                      <td>
                        {details.general_ward_6_approved_year
                          ? details.general_ward_6_approved_year
                          : "" + "/" + details.general_ward_6_approved_month
                            ? details.general_ward_6_approved_month
                            : "" + "/" + details.general_ward_6_approved_day
                              ? details.general_ward_6_approved_day
                              : ""}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>合計</td>
                      <td>
                        {details.general_ward_total_number_of_wards
                          ? details.general_ward_total_number_of_wards
                          : ""}
                      </td>
                      <td>
                        {details.general_ward_total_number_of_beds
                          ? details.general_ward_total_number_of_beds
                          : ""}
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td rowSpan="7">精神病棟</td>
                      <td>
                        {details.psychiatric_ward_flag
                          ? details.psychiatric_ward_flag
                          : ""}
                      </td>
                      <td>
                        {details.psychiatric_ward_1_nursing_type
                          ? details.psychiatric_ward_1_nursing_type
                          : ""}
                      </td>
                      <td>
                        {details.psychiatric_ward_1_number_of_wards
                          ? details.psychiatric_ward_1_number_of_wards
                          : ""}
                      </td>
                      <td>
                        {details.psychiatric_ward_1_number_of_beds
                          ? details.psychiatric_ward_1_number_of_beds
                          : ""}
                      </td>
                      <td>
                        {details.psychiatric_ward_1_approved_year
                          ? details.psychiatric_ward_1_approved_year
                          : "" + "/" + details.psychiatric_ward_1_approved_month
                            ? details.psychiatric_ward_1_approved_month
                            : "" + "/" + details.psychiatric_ward_1_approved_day
                              ? details.psychiatric_ward_1_approved_day
                              : ""}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {details.psychiatric_ward_2_nursing_type
                          ? details.psychiatric_ward_2_nursing_type
                          : ""}
                      </td>
                      <td>
                        {details.psychiatric_ward_2_number_of_wards
                          ? details.psychiatric_ward_2_number_of_wards
                          : ""}
                      </td>
                      <td>
                        {details.psychiatric_ward_2_number_of_beds
                          ? details.psychiatric_ward_2_number_of_beds
                          : ""}
                      </td>
                      <td>
                        {details.psychiatric_ward_2_approved_year
                          ? details.psychiatric_ward_2_approved_year
                          : "" + "/" + details.psychiatric_ward_2_approved_month
                            ? details.psychiatric_ward_2_approved_month
                            : "" + "/" + details.psychiatric_ward_2_approved_day
                              ? details.psychiatric_ward_2_approved_day
                              : ""}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {details.psychiatric_ward_3_nursing_type
                          ? details.psychiatric_ward_3_nursing_type
                          : ""}
                      </td>
                      <td>
                        {details.psychiatric_ward_3_number_of_wards
                          ? details.psychiatric_ward_3_number_of_wards
                          : ""}
                      </td>
                      <td>
                        {details.psychiatric_ward_3_number_of_beds
                          ? details.psychiatric_ward_3_number_of_beds
                          : ""}
                      </td>
                      <td>
                        {details.psychiatric_ward_3_approved_year
                          ? details.psychiatric_ward_3_approved_year
                          : "" + "/" + details.psychiatric_ward_3_approved_month
                            ? details.psychiatric_ward_3_approved_month
                            : "" + "/" + details.psychiatric_ward_3_approved_day
                              ? details.psychiatric_ward_3_approved_day
                              : ""}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {details.psychiatric_ward_4_nursing_type
                          ? details.psychiatric_ward_4_nursing_type
                          : ""}
                      </td>
                      <td>
                        {details.psychiatric_ward_4_number_of_wards
                          ? details.psychiatric_ward_4_number_of_wards
                          : ""}
                      </td>
                      <td>
                        {details.psychiatric_ward_4_number_of_beds
                          ? details.psychiatric_ward_4_number_of_beds
                          : ""}
                      </td>
                      <td>
                        {details.psychiatric_ward_4_approved_year
                          ? details.psychiatric_ward_4_approved_year
                          : "" + "/" + details.psychiatric_ward_4_approved_month
                            ? details.psychiatric_ward_4_approved_month
                            : "" + "/" + details.psychiatric_ward_4_approved_day
                              ? details.psychiatric_ward_4_approved_day
                              : ""}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {details.psychiatric_ward_5_nursing_type
                          ? details.psychiatric_ward_5_nursing_type
                          : ""}
                      </td>
                      <td>
                        {details.psychiatric_ward_5_number_of_wards
                          ? details.psychiatric_ward_5_number_of_wards
                          : ""}
                      </td>
                      <td>
                        {details.psychiatric_ward_5_number_of_beds
                          ? details.psychiatric_ward_5_number_of_beds
                          : ""}
                      </td>
                      <td>
                        {details.psychiatric_ward_5_approved_year
                          ? details.psychiatric_ward_5_approved_year
                          : "" + "/" + details.psychiatric_ward_5_approved_month
                            ? details.psychiatric_ward_5_approved_month
                            : "" + "/" + details.psychiatric_ward_5_approved_day
                              ? details.psychiatric_ward_5_approved_day
                              : ""}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {details.psychiatric_ward_6_nursing_type
                          ? details.psychiatric_ward_6_nursing_type
                          : ""}
                      </td>
                      <td>
                        {details.psychiatric_ward_6_number_of_wards
                          ? details.psychiatric_ward_6_number_of_wards
                          : ""}
                      </td>
                      <td>
                        {details.psychiatric_ward_6_number_of_beds
                          ? details.psychiatric_ward_6_number_of_beds
                          : ""}
                      </td>
                      <td>
                        {details.psychiatric_ward_6_approved_year
                          ? details.psychiatric_ward_6_approved_year
                          : "" + "/" + details.psychiatric_ward_6_approved_month
                            ? details.psychiatric_ward_6_approved_month
                            : "" + "/" + details.psychiatric_ward_6_approved_day
                              ? details.psychiatric_ward_6_approved_day
                              : ""}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>合計</td>
                      <td>
                        {details.psychiatric_ward_total_number_of_wards
                          ? details.psychiatric_ward_total_number_of_wards
                          : ""}
                      </td>
                      <td>
                        {details.psychiatric_ward_total_number_of_beds
                          ? details.psychiatric_ward_total_number_of_beds
                          : ""}
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td rowSpan="5">結核病棟</td>
                      <td>
                        {details.tuberculosis_ward_flag
                          ? details.tuberculosis_ward_flag
                          : ""}
                      </td>
                      <td>
                        {details.tuberculosis_ward_1_nursing_type
                          ? details.tuberculosis_ward_1_nursing_type
                          : ""}
                      </td>
                      <td>
                        {details.tuberculosis_ward_1_number_of_wards
                          ? details.tuberculosis_ward_1_number_of_wards
                          : ""}
                      </td>
                      <td>
                        {details.tuberculosis_ward_1_number_of_beds
                          ? details.tuberculosis_ward_1_number_of_beds
                          : ""}
                      </td>
                      <td>
                        {details.tuberculosis_ward_1_approved_year
                          ? details.tuberculosis_ward_1_approved_year
                          : "" +
                            "/" +
                            details.tuberculosis_ward_1_approved_month
                            ? details.tuberculosis_ward_1_approved_month
                            : "" + "/" + details.tuberculosis_ward_1_approved_day
                              ? details.tuberculosis_ward_1_approved_day
                              : ""}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {details.tuberculosis_ward_2_nursing_type
                          ? details.tuberculosis_ward_2_nursing_type
                          : ""}
                      </td>
                      <td>
                        {details.tuberculosis_ward_2_number_of_wards
                          ? details.tuberculosis_ward_2_number_of_wards
                          : ""}
                      </td>
                      <td>
                        {details.tuberculosis_ward_2_number_of_beds
                          ? details.tuberculosis_ward_2_number_of_beds
                          : ""}
                      </td>
                      <td>
                        {(details.tuberculosis_ward_2_approved_year
                          ? details.tuberculosis_ward_2_approved_year + " /"
                          : "") +
                          (details.tuberculosis_ward_2_approved_month
                            ? details.tuberculosis_ward_2_approved_month + "/"
                            : "") +
                          (details.tuberculosis_ward_2_approved_day
                            ? details.tuberculosis_ward_2_approved_day
                            : "")}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {details.tuberculosis_ward_3_nursing_type
                          ? details.tuberculosis_ward_3_nursing_type
                          : ""}
                      </td>
                      <td>
                        {details.tuberculosis_ward_3_number_of_wards
                          ? details.tuberculosis_ward_3_number_of_wards
                          : ""}
                      </td>
                      <td>
                        {details.tuberculosis_ward_3_number_of_beds
                          ? details.tuberculosis_ward_3_number_of_beds
                          : ""}
                      </td>
                      <td>
                        {details.tuberculosis_ward_3_approved_year
                          ? details.tuberculosis_ward_3_approved_year
                          : "" +
                            "/" +
                            details.tuberculosis_ward_3_approved_month
                            ? details.tuberculosis_ward_3_approved_month
                            : "" + "/" + details.tuberculosis_ward_3_approved_day
                              ? details.tuberculosis_ward_3_approved_day
                              : ""}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {details.tuberculosis_ward_4_nursing_type
                          ? details.tuberculosis_ward_4_nursing_type
                          : ""}
                      </td>
                      <td>
                        {details.tuberculosis_ward_4_number_of_wards
                          ? details.tuberculosis_ward_4_number_of_wards
                          : ""}
                      </td>
                      <td>
                        {details.tuberculosis_ward_4_number_of_beds
                          ? details.tuberculosis_ward_4_number_of_beds
                          : ""}
                      </td>
                      <td>
                        {details.tuberculosis_ward_4_approved_year
                          ? details.tuberculosis_ward_4_approved_year
                          : "" +
                            "/" +
                            details.tuberculosis_ward_4_approved_month
                            ? details.tuberculosis_ward_4_approved_month
                            : "" + "/" + details.tuberculosis_ward_4_approved_day
                              ? details.tuberculosis_ward_4_approved_day
                              : ""}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>合計</td>
                      <td>
                        {details.tuberculosis_ward_total_number_of_wards
                          ? details.tuberculosis_ward_total_number_of_wards
                          : ""}
                      </td>
                      <td>
                        {details.tuberculosis_ward_total_number_of_beds
                          ? details.tuberculosis_ward_total_number_of_beds
                          : ""}
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td rowSpan="8">その他病棟</td>
                      <td></td>
                      <td>
                        {details.other_1_nursing_type
                          ? details.other_1_nursing_type
                          : ""}
                      </td>
                      <td>-</td>
                      <td>
                        {details.other_1_number_of_beds
                          ? details.other_1_number_of_beds
                          : ""}
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {details.other_2_nursing_type
                          ? details.other_2_nursing_type
                          : ""}
                      </td>
                      <td>-</td>
                      <td>
                        {details.other_2_number_of_beds
                          ? details.other_2_number_of_beds
                          : ""}
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {details.other_3_nursing_type
                          ? details.other_3_nursing_type
                          : ""}
                      </td>
                      <td>-</td>
                      <td>
                        {details.other_3_number_of_beds
                          ? details.other_3_number_of_beds
                          : ""}
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {details.other_4_nursing_type
                          ? details.other_4_nursing_type
                          : ""}
                      </td>
                      <td>-</td>
                      <td>
                        {details.other_4_number_of_beds
                          ? details.other_4_number_of_beds
                          : ""}
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {details.other_5_nursing_type
                          ? details.other_5_nursing_type
                          : ""}
                      </td>
                      <td>-</td>
                      <td>
                        {details.other_5_number_of_beds
                          ? details.other_5_number_of_beds
                          : ""}
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {details.other_6_nursing_type
                          ? details.other_6_nursing_type
                          : ""}
                      </td>
                      <td>-</td>
                      <td>
                        {details.other_6_number_of_beds
                          ? details.other_6_number_of_beds
                          : ""}
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {details.other_7_nursing_type
                          ? details.other_7_nursing_type
                          : ""}
                      </td>
                      <td>-</td>
                      <td>
                        {details.other_7_number_of_beds
                          ? details.other_7_number_of_beds
                          : ""}
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {details.other_8_nursing_type
                          ? details.other_8_nursing_type
                          : ""}
                      </td>
                      <td>-</td>
                      <td>
                        {details.other_8_number_of_beds
                          ? details.other_8_number_of_beds
                          : ""}
                      </td>
                      <td>-</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <div className="table-responsive mb-0 max-height">
                <table className="table no-th" aria-describedby="table">
                  <tbody>
                    <tr>
                      <td>療養病床数</td>
                      <td>感染病床数</td>
                      <td>ハンセン病床数</td>
                    </tr>
                    <tr>
                      <td>
                        {details.number_of_recuperation_beds
                          ? details.number_of_recuperation_beds
                          : ""}
                      </td>
                      <td>
                        {details.infected_beds_number_of_beds
                          ? details.infected_beds_number_of_beds
                          : ""}
                      </td>
                      <td>
                        {details.number_of_leprosy_beds
                          ? details.number_of_leprosy_beds
                          : ""}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="md"
        className="withdraw-modal"
        show={customerNotFound}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="warning-msg">
            <img src="images/warning2.svg" alt="Warning" />
            {lang("errorMessages.CUSTOMER_NOT_FOUND")}
          </div>
          <p className="mb-3">
            {lang("errorMessages.SEARCH_REQUESTS")}
            <a
              className="link"
              onClick={(e) => {
                changeRoute(e, "/organizationCustomer");
              }}
            >
              {lang("Menu.organizationCustomer")}
            </a>
          </p>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default NursingInfo;
